<template>
  <div v-bind="$attrs" :class="classes" v-on="$listeners">
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseRow",
  inheritAttrs: false,
  props: {
    /** Equal-width columns per row (1–12 or `true` for auto) */
    rowCols: { type: [String, Number, Boolean], default: null },
    rowColsSm: { type: [String, Number, Boolean], default: null },
    rowColsMd: { type: [String, Number, Boolean], default: null },
    rowColsLg: { type: [String, Number, Boolean], default: null },
    rowColsXl: { type: [String, Number, Boolean], default: null },
    rowColsXxl: { type: [String, Number, Boolean], default: null },

    /** Remove gutters (Bootstrap 4 `.no-gutters`, BS5 `.g-0`) */
    noGutters: { type: Boolean, default: false },

    /** Vertical alignment: start | center | end | baseline | stretch */
    alignV: { type: String, default: null },

    /** Horizontal justification: start | center | end | between | around | evenly */
    alignH: { type: String, default: null },
  },
  computed: {
    classes() {
      const cls = ["row"];
      const add = (prefix, val) => {
        if (val === true) {
          // auto-cols
          cls.push(prefix);
        } else if (val != null && val !== false) {
          cls.push(`${prefix}-${val}`);
        }
      };

      // row-cols utilities
      add("row-cols", this.rowCols);
      add("row-cols-sm", this.rowColsSm);
      add("row-cols-md", this.rowColsMd);
      add("row-cols-lg", this.rowColsLg);
      add("row-cols-xl", this.rowColsXl);
      add("row-cols-xxl", this.rowColsXxl);

      // no gutters
      if (this.noGutters) {
        cls.push("no-gutters", "g-0");
      }

      // vertical align
      if (this.alignV) {
        cls.push(`align-items-${this.alignV}`);
      }

      // horizontal justify
      if (this.alignH) {
        cls.push(`justify-content-${this.alignH}`);
      }

      return cls;
    },
  },
};
</script>
